import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaCreditoOrcamentarioReceitasProprias: ['exercicio'],
    setAdministracaoConsultaCreditoOrcamentarioReceitasProprias: ['administracao'],
    setRecursoConsultaCreditoOrcamentarioReceitasProprias: ['recurso'],
    setDestinacaoConsultaCreditoOrcamentarioReceitasProprias: ['destinacao'],
    setMoedaConsultaCreditoOrcamentarioReceitasProprias: ['moeda'],
    setGrauConsultaCreditoOrcamentarioReceitasProprias: ['grau'],
    limpaFiltroConsultaCreditoOrcamentarioReceitasProprias: [],
    receberFiltroConsultaCreditoOrcamentarioReceitasProprias: ['filtroRecebido'],
    setStatusConsultaCreditoOrcamentarioReceitasProprias: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    recurso: [],
    destinacao: [],
    moeda: [],
    grau: '',
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const setMoeda = (state = INITIAL_STATE, action) => {
    return { ...state, moeda: action.moeda }
}

const setGrau = (state = INITIAL_STATE, action) => {
    return { ...state, grau: action.grau }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setAdministracao,
    [Types.SET_RECURSO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setDestinacao,
    [Types.SET_MOEDA_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setMoeda,
    [Types.SET_GRAU_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setGrau,
    [Types.LIMPA_FILTRO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setStatus,
})
